<template>
  <div class="edit_class-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="goBack" class="nav-wrap">
        <p class="title">编辑培训班</p>
      </yioks-page-nav>
      <div class="content-wrap">
        <vue-scroll :ops="vuescrollOpt">
          <div class="form-wrap">
            <el-form
                :model="formData"
                :rules="formRules"
                ref="mainForm"
                label-width="150px"
                size="medium"
                class="form-cont"
            >
              <el-form-item label="主办机构" class="inline-item-wrap" required>
                <el-form-item
                    v-for="(item, index) in formData.hostOrg"
                    label-width="0px"
                    :prop="'hostOrg.' + index + '.val'"
                    :rules="{required: true, message: `此项不能为空`, trigger: `blur`}"
                    class="form-input-item"
                    :key="item.key"
                >
                  <el-input
                      :placeholder="item.placeholder"
                      v-model.trim="item.val"
                      class="input-w260"
                  ></el-input>
                  <i
                      v-if="index > 0"
                      class="input-icon el-icon-close"
                      @click="removeHost(item, 'hostOrg')"
                  ></i>
                </el-form-item>
                <el-button
                    type="primary"
                    size="medium"
                    icon="el-icon-plus"
                    @click="addHost('hostOrg', {val: '', key: Date.now(), placeholder: '请填写主办机构'})"
                    :disabled="formData.hostOrg.length > 1"
                    class="form-item-btn"
                >更多
                </el-button>
              </el-form-item>
              <!-- debugger 暂时隐藏 -->
              <el-form-item label="培训举办地" class="inline-item-wrap" v-if="selectAddress.length && false">
                  <el-select v-model="formData.selectedAddress"
                    class="input-w260" @change="handleAddressChange" placeholder="请选择投标举办地" clearable>
                    <el-option v-for="(item, index) in selectAddress" :key="index" :label="item.label" :value="item.value"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="承办机构" class="inline-item-wrap">
                <el-form-item
                    v-for="(item, index) in formData.underOrg"
                    label-width="0px"
                    :prop="'underOrg.' + index + '.val'"
                    class="form-input-item"
                    :key="item.key"
                >
                  <el-input
                      :placeholder="item.placeholder"
                      v-model.trim="item.val"
                      class="input-w260"
                  ></el-input>
                  <i
                      v-if="index > 0"
                      class="input-icon el-icon-close"
                      @click="removeHost(item, 'underOrg')"
                  ></i>
                </el-form-item>
                <el-button
                    type="primary"
                    size="medium"
                    icon="el-icon-plus"
                    @click="addHost('underOrg', {val: '', key: Date.now(), placeholder: '请填写承办机构'})"
                    :disabled="formData.underOrg.length > 1"
                    class="form-item-btn"
                >更多
                </el-button>
              </el-form-item>
              <el-form-item label="协办机构" class="inline-item-wrap">
                <el-form-item
                    v-for="(item, index) in formData.assistOrg"
                    label-width="0px"
                    :prop="'assistOrg.' + index + '.val'"
                    class="form-input-item"
                    :key="item.key"
                >
                  <el-input
                      :placeholder="item.placeholder"
                      v-model.trim="item.val"
                      class="input-w260"
                  ></el-input>
                  <i
                      v-if="index > 0"
                      class="input-icon el-icon-close"
                      @click="removeHost(item, 'assistOrg')"
                  ></i>
                </el-form-item>
                <el-button
                    type="primary"
                    size="medium"
                    icon="el-icon-plus"
                    @click="addHost('assistOrg', {val: '', key: Date.now(), placeholder: '请填写协办机构'})"
                    :disabled="formData.assistOrg.length > 1"
                    class="form-item-btn"
                >更多
                </el-button>
              </el-form-item>
              <el-form-item label="培训班级别" prop="className" class>
                <el-select v-model="formData.class_level" disabled
                           @change="selectLevel"
                           class="input-w260"
                           placeholder="请选择培训班级别">
                  <el-option
                      v-for="item in levelOptions"
                      :key="item.val"
                      :label="item.text"
                      :value="item.val">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="培训班名称" prop="className" class="">
                <el-input
                    disabled
                    v-model.trim="formData.className"
                    class="input-w260 class-input"
                    placeholder="请填写培训班名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="开班地区" required class="inline-item-wrap">
                <el-form-item
                    label-width="0px"
                    prop="classAddress.province"
                    :rules="{required: true, validator: validateProvince, trigger: `change`}"
                    class="form-input-item"
                >
                  <el-select v-model="formData.classAddress.province" class="hide"></el-select>
                  <select
                      class="set-sel input-w200"
                      @change="provinceChange"
                      v-model="formData.classAddress.province"
                      :style="{border: provinceSelErr === true ? selTestErrorBorder: (periodSelErr === false ? selTestRightBorder : '')}"
                  >
                    <option value="">请选择省份</option>
                    <option
                        v-for="(province) in provinceList"
                        :key="province.id"
                        :value="province.id"
                    >{{province.text}}
                    </option>
                  </select>
                </el-form-item>
                <el-form-item
                    label-width="0px"
                    prop="classAddress.city"
                    :rules="{required: true, validator: validateCity, trigger: `change`}"
                    class="form-input-item"
                >
                  <el-select v-model="formData.classAddress.city" class="hide"></el-select>
                  <select
                      class="set-sel input-w200"
                      @change="cityChange"
                      v-model="formData.classAddress.city"
                      :style="{border: citySelErr === true ? selTestErrorBorder: (periodSelErr === false ? selTestRightBorder : '')}"
                  >
                    <option value="">请选择市</option>
                    <option v-for="(city) in cityList" :key="city.id" :value="city.id">{{city.text}}</option>
                  </select>
                </el-form-item>
                <el-form-item
                    label-width="0px"
                    prop="classAddress.county"
                    :rules="{required: isCountyNeeded, validator: validateCounty, trigger: `change`}"
                    class="form-input-item"
                >
                  <el-select v-model="formData.classAddress.county" class="hide"></el-select>
                  <select
                      class="set-sel input-w200"
                      v-model="formData.classAddress.county"
                      :style="{border: countySelErr === true ? selTestErrorBorder: (countySelErr === false ? selTestRightBorder : '')}"
                  >
                    <option value>请选择县区</option>
                    <option
                        v-for="(item) in countyList"
                        :key="item.id"
                        :value="item.id"
                    >{{item.text}}
                    </option>
                  </select>
                </el-form-item>
              </el-form-item>
              <el-form-item label="培训日期" required>
                <template v-if="showDateTime">
                  <el-form-item prop="trainStart" class="date-form-item">
                    <el-date-picker
                        type="date"
                        :editable="false"
                        :clearable="false"
                        @change="changeState"
                        :picker-options="trainStartOpt"
                        value-format="timestamp"
                        placeholder="请选择开始时间"
                        v-model="formData.trainStart"
                        style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                  <span class="date-form-text">————</span>
                  <el-form-item prop="trainEnd" class="date-form-item">
                    <el-date-picker
                        type="date"
                        :editable="false"
                        :clearable="false"
                        value-format="timestamp"
                        :picker-options="trainEndOpt"
                        placeholder="请选择结束时间"
                        v-model="formData.trainEnd"
                        style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </template>
              </el-form-item>
              <el-form-item class="traindate-tip">
                <div class="text">注：培训日期结束，学员帐号将自动关闭~</div>
              </el-form-item>
              <el-form-item label="期数" prop="period" class>
                <span class="text_di">第</span>
                <el-input-number v-model="formData.period" controls-position="right" :min="1"></el-input-number>
                <span class="text_qi">期</span>
              </el-form-item>
              <el-form-item label="主讲师" prop="lecturer">
                <el-select v-model="formData.lecturer"
                           :default-first-option="true"
                           :filter-method="lecturerFilter"
                           @blur="lecturerBlur"
                           filterable>
                  <el-option label="足协指派"
                             value=""></el-option>
                  <el-option
                      v-for="tea in lecturerList"
                      :key="tea.user_id"
                      :label="`${tea.teacher_name_unit}`"
                      :value="tea.user_id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="助理讲师" class="inline-item-wrap form-item-nomb">
                <el-form-item
                    v-for="(item, index) in formData.assistantLecturer"
                    label-width="0px"
                    :prop="'assistantLecturer.' + index + '.val'"
                    :rules="{validator: (rule, val,callback) => {return validateAssLec(rule, val,callback, index)}, trigger: `change`}"
                    class="form-input-item input-item-hasmb"
                    :key="item.key"
                >
                  <el-select v-model="item.val"
                             :default-first-option="true"
                             :filter-method="assistantFilter"
                             @focus="assistantIdx = index"
                             @blur="assistantBlur"
                             clearable
                             filterable>
                    <el-option :label="item.placeholder"
                               value="" v-if="!['super','system'].includes(userType) "></el-option>
                    <el-option label="足协指派"
                      value="足协指派" v-if="!['super','system'].includes(userType) "></el-option>
                    <el-option
                        v-for="lecturer in assistantLecturerList"
                        :key="lecturer.user_id"
                        :label="`${lecturer.teacher_name_unit}`"
                        :value="lecturer.user_id"
                    ></el-option>
                  </el-select>
                  <i
                      v-if="index > 0"
                      class="input-icon el-icon-close"
                      @click="removeHost(item, 'assistantLecturer')"
                  ></i>
                </el-form-item>
                <el-button
                    type="primary"
                    size="medium"
                    icon="el-icon-plus"
                    @click="addHost('assistantLecturer', {val: '', key: Date.now(), placeholder: '(空)', isTestErr: null}, assistantLecturerList.length - 1)"
                    :disabled="formData.assistantLecturer.length > assistantLecturerList.length - 1"
                    class="form-item-btn button-hasmb"
                  v-if="formData.assistantLecturer.length <2"
                >更多
                </el-button>
              </el-form-item>
              <el-form-item label="讲师助理" class="inline-item-wrap form-item-nomb" v-if="formData.class_level === 'D'">
                <el-form-item
                  v-for="(item, index) in formData.teacher_zhuli"
                  label-width="0px"
                  :prop="'teacher_zhuli.' + index + '.val'"
                  class="flex-form-item1"
                  :key="item.key"
                >
                  <el-form-item
                    label="姓名"
                    label-width="50px"
                    :prop="'teacher_zhuli.' + index + '.name'">
                    <el-input
                      placeholder="请输入姓名"
                      v-model="item.name"
                      class=" input-item-hasmb"
                      style="width:100px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="身份证号"
                    class="id_number_tips_error"
                    :prop="'teacher_zhuli.' + index + '.id_number'"
                    :rules="{required: false, validator: (rule, value, callback) => {validateNumberIdNO(rule, value, callback, true, index)}, trigger: 'blur'}"
                    label-width="85px">
                    <el-input
                      placeholder="请输入身份证件号"
                      v-model="item.id_number"
                      class=" input-item-hasmb"
                      style="width:150px"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="证件类型"
                    label-width="85px"
                    :prop="'teacher_zhuli.' + index + '.id_type'"
                    :rules="{required:false,message:'请选择证件类型',trigger:'change'}"
                    >
                    <el-select v-model="item.id_type" style='width:150px' class=" input-item-hasmb">
                      <el-option
                        v-for="it in id_types"
                        :key="it.key"
                        :label="it.key"
                        :value="it.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <i
                    v-if="index > 0"
                    class="input-icon el-icon-close"
                    style="right:80px"
                    @click="removeHost(item, 'teacher_zhuli')"
                  ></i>
                  <el-button
                    type="primary"
                    size="medium"
                    icon="el-icon-plus"
                    @click="addHost('teacher_zhuli', {name: '', key: Date.now(), id_number: '',id_type:'id_number'}, 2)"
                    class="form-item-btn"
                    style="margin-bottom: 20px;margin-left: 10px;width:70px;padding: 10px;"
                    v-if="formData.teacher_zhuli.length<2"
                  >更多
                  </el-button>
                </el-form-item>
                
              </el-form-item>
              <el-form-item label="实习讲师" class="inline-item-wrap form-item-nomb">
                <el-form-item
                    v-for="(item, index) in formData.fieldworkLecturer"
                    label-width="0px"
                    :prop="'fieldworkLecturer.' + index + '.val'"
                    class="form-input-item"
                    :key="item.key"
                >
                  <el-input
                      :placeholder="item.placeholder"
                      v-model="item.val"
                      class="input-w200 input-item-hasmb"
                  ></el-input>
                  <i
                      v-if="index > 0"
                      class="input-icon el-icon-close"
                      @click="removeHost(item, 'fieldworkLecturer')"
                  ></i>
                </el-form-item>
                <el-button
                    type="primary"
                    size="medium"
                    icon="el-icon-plus"
                    @click="addHost('fieldworkLecturer', {val: '', key: Date.now(), placeholder: '实习讲师'}, 5)"
                    :disabled="formData.fieldworkLecturer.length > 5"
                    class="form-item-btn button-hasmb"
                >更多
                </el-button>
              </el-form-item>
              <el-form-item v-if="formData.class_level === 'C'"
                            label="快速培训通道"
                            class="test-inline">
                <el-radio-group v-model="formData.is_special_train">
                  <el-radio :label="0" border>否</el-radio>
                  <el-radio :label="1" border>是</el-radio>
                </el-radio-group>
                <p class="no">注：C级学员快速培训通道，允许特批的“整班学员”在D级不够12个月参加C的培训(为职业足球运动员保留)</p>
              </el-form-item>
              <el-form-item label="学员名单" prop="saveStus" required class="test-inline">
                <el-button type="primary" @click="showExcelDialog">批量录入</el-button>
                <el-button type="primary" @click="showStusDialog">录入名单</el-button>
                <span :class="['tip', testStus ? 'yes':'no']">{{testStus?'学员添加成功':'学员未添加'}}</span>
              </el-form-item>

              <el-form-item label="培训课表" prop="curriculum" class="up-form-item">
                <div class="upfile-wrap">
                  <image-up
                      :lt-size="{msg: '上传图片大小不能超过10MB!',reg: 10}"
                      :lt-format="{msg: '仅支持jpg,jpeg,png,gif格式的图片',reg: /^.*\.(jpg|png|jpeg|gif)$/i }"
                      :imgval.sync="formData.curriculum"
                      :cover='timetableCover'
                      :dw="'830px'"
                      :dt="'10vh'"
                  ></image-up>
                  <p class="tip">支持jpg,jpeg,png,gif格式的图片</p>
                </div>
              </el-form-item>
              <el-form-item label="培训费用" prop="cost" class="">
                <el-input
                    v-model.trim="formData.cost"
                    class="input-w260 class-input"
                    placeholder="请填写培训费用"
                ></el-input>
                <span class="cost-text">单位：元</span>
              </el-form-item>
              <el-form-item label="是否统一安排住宿" class="flex-form-item">
                <el-switch v-model="formData.ifLodging"></el-switch>
                <el-form-item
                    label="住宿地点"
                    prop="lodgingPlace"
                    label-width="110px"
                    class=""
                >
                  <el-input
                      v-model.trim="formData.lodgingPlace"
                      :disabled="!formData.ifLodging"
                      class="input-w200 class-input"
                      placeholder="请填写住宿地点"
                  ></el-input>
                </el-form-item>
                <el-form-item
                    label="费用"
                    prop="lodgingPrice"
                    label-width="80px"
                    class=""
                >
                  <el-select
                      v-model="formData.lodgingPrice"
                      class="hide"
                      :disabled="!formData.ifLodging"
                  ></el-select>
                  <select
                      class="set-sel input-w200"
                      v-model="formData.lodgingPrice"
                      :disabled="!formData.ifLodging"
                  >
                    <!-- <option value="">请选择讲师</option> -->
                    <option
                        v-for="(item) in lodgingSelList"
                        :key="item.val"
                        :value="item.val"
                    >{{item.text}}
                    </option>
                  </select>
                </el-form-item>
              </el-form-item>
              <el-form-item label="是否统一安排就餐" class="flex-form-item">
                <el-switch v-model="formData.ifEat"></el-switch>
                <el-form-item
                    label="就餐地点"
                    prop="eatPlace"
                    label-width="110px"
                    class=""
                >
                  <el-input
                      v-model.trim="formData.eatPlace"
                      :disabled="!formData.ifEat"
                      class="input-w200 class-input"
                      placeholder="请填写就餐地点"
                  ></el-input>
                </el-form-item>
                <el-form-item label="餐费" prop="eatPrice" label-width="80px" class="">
                  <el-select v-model="formData.eatPrice" class="hide" :disabled="!formData.ifEat"></el-select>
                  <select
                      class="set-sel input-w200"
                      v-model="formData.eatPrice"
                      :disabled="!formData.ifEat"
                  >
                    <!-- <option value="">请选择讲师</option> -->
                    <option
                        v-for="(item) in eatSelList"
                        :key="item.val"
                        :value="item.val"
                    >{{item.text}}
                    </option>
                  </select>
                </el-form-item>
              </el-form-item>
              <el-form-item label="是否统一安排差旅" class="flex-form-item">
                <el-switch v-model="formData.ifTravel"></el-switch>
                <el-form-item label="旅费" prop="travelPrice" label-width="110px" class>
                  <el-select v-model="formData.travelPrice" class="hide" :disabled="!formData.ifTravel"></el-select>
                  <select
                    class="set-sel input-w200"
                    v-model="formData.travelPrice"
                    :disabled="!formData.ifTravel"
                  >
                    <!-- <option value="">请选择讲师</option> -->
                    <option
                      v-for="(item) in travelList"
                      :key="item.val"
                      :value="item.val"
                    >{{item.text}}</option>
                  </select>
                  <!-- <el-input
                    v-model="formData.eatPrice"
                    :disabled='!formData.ifEat'
                    class="input-w200 "
                    placeholder="请填写餐费"
                  ></el-input>-->
                </el-form-item>
              </el-form-item>
              <el-form-item label="报到时间" required>
                <template v-if="showDateTime">
                  <el-form-item prop="reportStart" class="date-form-item">
                    <el-date-picker
                        :editable="false"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        format="yyyy 年 MM 月 dd 日"
                        :picker-options="reportStartOpt"
                        v-model="formData.reportStart"
                        placeholder="请选择开始日期"
                        type="date"
                        style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                  <span class="date-form-text">—</span>
                  <el-form-item prop="reportEnd" class="date-form-item">
                    <el-time-select
                        v-model="formData.reportEnd"
                        :editable="false"
                        :clearable="false"
                        :picker-options="{
                        start: '07:00',
                        step: '00:10',
                        end: '18:30',
                      }"
                        placeholder="请选择开始时间"
                        style="width: 100%;"
                    ></el-time-select>
                  </el-form-item>
                </template>
              </el-form-item>
              <el-form-item label="离会时间" required>
                <template v-if="showDateTime">
                  <el-form-item prop="leaveDate" class="date-form-item">
                    <el-date-picker
                        :editable="false"
                        :clearable="false"
                        value-format="yyyy-MM-dd"
                        format="yyyy 年 MM 月 dd 日"
                        :picker-options="leaveDateOpt"
                        v-model="formData.leaveDate"
                        placeholder="请选择离会日期"
                        type="date"
                        style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                  <span class="date-form-text">—</span>
                  <el-form-item prop="leaveTime" class="date-form-item">
                    <el-time-select
                        v-model="formData.leaveTime"
                        :editable="false"
                        :clearable="false"
                        :picker-options="{
                        start: '07:00',
                        step: '00:10',
                        end: '18:30',
                      }"
                        placeholder="请选择离会时间"
                        style="width: 100%;"
                    ></el-time-select>
                  </el-form-item>
                </template>
              </el-form-item>
              <el-form-item label="报到地点" prop="reportAddress" class="">
                <el-input
                    v-model.trim="formData.reportAddress"
                    class="input-w260 class-input"
                    placeholder="请填写报到地点"
                ></el-input>
              </el-form-item>
              <el-form-item label="训练场地" prop="trainAddress" class="">
                <el-input
                    v-model.trim="formData.trainAddress"
                    class="input-w260 class-input"
                    placeholder="请填写训练场地"
                ></el-input>
              </el-form-item>
              <el-form-item label="理论课场地" prop="courseAddress" class="">
                <el-input
                    v-model.trim="formData.courseAddress"
                    class="input-w260 class-input"
                    placeholder="请填写理论课场地"
                ></el-input>
              </el-form-item>
              <el-form-item label="培训班协调员" prop='saveContact' class="test-inline">
                <el-button type="primary" @click="showContactDialog">添加培训班协调员</el-button>
                <span :class="['tip', testContact ? 'yes':'no']">{{testContact?'培训班协调员添加成功':'培训班协调员未添加'}}</span>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="post-btn">
        <template v-if="userType==='organ'">
          <el-button type="primary" @click="startClass('Audit')">提交审核</el-button>
          <el-button @click="startClass('Edit')">暂时保存</el-button>
        </template>
        <template v-else>
          <el-button type="primary"
                     @click="startClass(formData.status)">保存
          </el-button>
          <el-button type="danger"
                     class="cancel_btn"
                     @click="goBack">取消
          </el-button>
        </template>
      </div>
    </div>
    <el-dialog
        @closed="excelDiaCloseHandle"
        :visible.sync="ifExcelDiaShow"
        :close-on-click-modal="false"
        top="13vh"
        width="500px"
        class="yi-dialog-root"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">批量录入</span>
      </div>
      <div class="excel-dia-content">
        <div class="excel-main">
          <!-- <p class="upload-tips"><span style="color:red">温馨提示：</span> 2020年起开设的培训班将使用支持非大陆学员报名的新模板，旧模板将无法使用。</p> -->
          <file-upload
              action="/api/organization/student_up_excel.json"
              :test_file="testFile"
              :val.sync="excelVal"
              ref="excelUpload"
          >
          </file-upload>
          <p class="upload-tips">
            <span>请上传 excel 文件 或&nbsp;</span>
            <a :href="loadExcelUrl"
               download="">下载模板</a>
            <span>&nbsp;编辑后上传</span>
          </p>
        </div>
      </div>
      <div class="footer-btn" slot="footer">
        <div class="btns">
          <div class="btn save"
               @click="saveExcelData">保存
          </div>
          <div class="btn cancel"
               @click="ifExcelDiaShow = false">取消
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        @open="stuDiaOpenHandle"
        :visible.sync="ifStuDiaShow"
        :close-on-click-modal="false"
        top="13vh"
        width="1024px"
        class="yi-dialog-root scroll-dialog"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">录入学员名单</span>
        <span class="prompt">注：学员手机号将作为登录培训系统的初始密码~</span>
      </div>
      <div class="dialog-content">
        <vue-scroll :ops="disScrollOpt" ref="stuVs">
          <div class="dia-scroll-content">
            <el-form
                :model="stusData"
                ref="stusDialogForm"

                size="medium"
                class="dia-form"
                :inline="true"
            >
              <div
                  class="form-oneline-wrap clearfix formPos"
                  v-for="(stu, index) in stusData.stusInfoList"
                  :key="stu.id"
              >
                <span class="num">{{index+1}}</span>
                <el-form-item
                    label="姓名"
                    label-width="77px"
                    :prop="'stusInfoList.' + index + '.name'"
                    :rules="{required: true, validator: (rule, value, callback) => {validateName(rule, value, callback, true, index)}, trigger: 'blur'}"
                    class="dia-input-wrap stu-name-wrap"
                >
                  <el-input placeholder="请输入姓名"
                            v-model="stu.name"
                            class="dia-input-w160 name-input"></el-input>
                </el-form-item>
                <el-form-item
                    label="手机号"
                    :prop="'stusInfoList.' + index + '.phone'"
                    :rules="{required: true, validator: (rule, value, callback) => {validatePhone(rule, value, callback, true, index)}, trigger: 'blur'}"
                    class="dia-input-wrap stu-phone-wrap"
                >
                  <el-input placeholder="请输入手机号"
                            v-model="stu.phone"
                            class="dia-input-w160 phone-input"></el-input>
                </el-form-item>
                <el-form-item label="证件类型"
                label-width="78px"
                :prop="'stusInfoList.' + index + '.id_type'"
                :rules="{required:true,message:'请选择证件类型',trigger:'change'}"
                class="dia-input-wrap stu-type-wrap" >
                  <el-select v-model="stu.id_type" style='width:200px'>
                    <el-option
                    v-for="item in id_types"
                    :key="item.key"
                    :label="item.key"
                    :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item
                  ref="s"
                    label="证件号"
                    :prop="'stusInfoList.' + index + '.id_num'"
                    :rules="{required: true, validator: (rule, value, callback) => {validateNumberId(rule, value, callback, true, index)}, trigger: 'blur'}"
                    class="dia-input-wrap stu-phone-wrap"
                >
                  <el-input placeholder="请输入证件号"
                            v-model.trim="stu.id_num"
                            class="dia-input-w180 number-input"></el-input>
                </el-form-item>
                <el-form-item v-if="formData.class_level === 'C' && formData.is_special_train == 0"
                              label="本学员是否为快速培训通道学员"
                              class="test-inline">
                  <el-radio-group v-model="stu.is_fast">
                    <el-radio :label="0" border>否</el-radio>
                    <el-radio :label="1" border>是</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item class="upload-content" :ref="'upload'+index" v-if="stu.is_fast === 1 && formData.is_special_train == 0" :prop=" stu.is_fast === 1 ? 'stusInfoList.' + index + '.fileList' : ''"
                              :rules="{required: true, validator: (rule, value, callback) => {validateFile(rule, value, callback, true, index)}, trigger: 'change'}">
                  <el-upload
                      :action="uploadAction"
                      :on-remove="
                            (file, fileList) =>
                              handleSocreDocRemove(file, fileList, index)
                          "
                      :limit="1"
                      :headers="fileUpHeaders"
                      :data="fileUpParam"
                      :on-exceed="
                            (file, fileList) =>
                              handleScoreDocUoloadCheck(file, fileList, index)
                          "
                      :file-list="stu.fileList"
                      :before-upload="(file) => beforeUpload(file)"
                      :on-success="
                            (res, file) => {
                              handleUploadScoreSuccess(res, file, index);
                            }
                          "
                  >
                    <el-button size="mini" type="primary"
                    >上传证明材料</el-button
                    >
                    <div slot="tip" class="el-upload__tip">
                      只能上传1个pdf文件，且不超过50M
                    </div>
                  </el-upload>
                </el-form-item>
                <div class="stu-opt">
                  <i :class="{'el-icon-circle-plus': true, 'opt-icon': true, add: stusData.stusInfoList.length<maxStus, disabled: stusData.stusInfoList.length>=maxStus}"
                     @click="addStus(index)"
                     v-if="index ===stusData.stusInfoList.length-1"></i>
                  <i :class="{'el-icon-remove': true, 'opt-icon': true, remove: stusData.stusInfoList.length>1, disabled: stusData.stusInfoList.length<=1}"
                     @click="removeStus(index)"></i>
                </div>
              </div>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="footer-btn" slot="footer">
        <!--<el-button type="primary" @click="saveStuList">保存</el-button>-->
        <!--<el-button type="info" @click="stuDiaEsc">取消</el-button>-->
        <div class="btns">
          <div class="btn save"
               @click="saveStuList">保存
          </div>
          <div class="btn cancel"
               @click="stuDiaEsc">取消
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        @open="contactDiaOpen"
        :visible.sync="ifContactDiaShow"
        :close-on-click-modal="false"
        top="13vh"
        width="855px"
        class="yi-dialog-root scroll-dialog"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title">添加培训班协调员</span>
        <!-- <span class="prompt">注：学员手机号将作为登录培训系统的初始密码~</span> -->
      </div>
      <div class="dialog-content contact-dia-content">
        <vue-scroll :ops="disScrollOpt">
          <div class="dia-scroll-content">
            <el-form
                :model="contactData"
                ref="contactDialogForm"
                label-width="80px"
                size="medium"
                class="dia-form"
            >
              <div
                  class="form-oneline-wrap clearfix"
                  v-for="(contact, index) in contactData.contactInfoList"
                  :key="contact.id"
              >
                <el-form-item
                    label="姓名"
                    :prop="'contactInfoList.' + index + '.name'"
                    :rules="{required: true, message: `不能为空`, trigger: `blur`}"
                    class="dia-input-wrap contact-name-wrap"
                >
                  <el-input placeholder="请输入联系人姓名" v-model="contact.name" class="dia-input-w100"></el-input>
                </el-form-item>
                <el-form-item
                    label="电话"
                    :prop="'contactInfoList.' + index + '.phone'"
                    :rules="{required: true, validator: (rule, value, callback) => {validatePhone(rule, value, callback, false)}, trigger: `blur`}"
                    class="dia-input-wrap contact-phone-wrap"
                >
                  <el-input placeholder="请输入联系人手机号" v-model="contact.phone" class="dia-input-w100"></el-input>
                </el-form-item>
                <el-form-item
                    label="邮箱"
                    :prop="'contactInfoList.' + index + '.email'"
                    :rules="{required: false, validator: (rule, value, callback) => {validateEmail(rule, value, callback, false)}, trigger: `blur`}"
                    class="dia-input-wrap contact-email-wrap"
                >
                  <el-input placeholder="请输入联系人邮箱" v-model="contact.email" class="dia-input-w100"></el-input>
                </el-form-item>
                <el-form-item
                  label="工作单位"
                  :prop="'contactInfoList.' + index + '.work'"
                  :rules="{required: false, validator: (rule, value, callback) => {validateStrLength(rule, value, callback, false)}, trigger: `blur`}"
                  class="dia-input-wrap contact-email-wrap"
                >
                  <el-input placeholder="请填写工作单位" v-model="contact.work" class="dia-input-w100"></el-input>
                </el-form-item>
                <el-button
                    class="form-oneline-btn"
                    size="medium"
                    type="danger"
                    v-if="index > 0"
                    @click="delContact(contact)"
                >删除
                </el-button>
                <el-button v-else class="form-oneline-btn " size="medium" type="primary" @click="addContact">添加
                </el-button>
              </div>
            </el-form>
            <div class="dia-center-btn">
              <!-- <el-button class="dia-add-btn" type="primary" @click="addContact">添加</el-button> -->
            </div>
          </div>
        </vue-scroll>
      </div>
      <div class="footer-btn" slot="footer">
        <!--<el-button type="primary" @click="saveContactList">保存</el-button>-->
        <!--<el-button type="info" @click="contactDiaEsc">取消</el-button>-->
        <div class="btns">
          <div class="btn save"
               @click="saveContactList">保存
          </div>
          <div class="btn cancel"
               @click="contactDiaEsc">取消
          </div>
        </div>
      </div>
    </el-dialog>
    <yioks-tips :showTips="backComfim" tips="确定放弃修改并返回吗？" @hideTips="backComfimDialog"></yioks-tips>
    <!-- hideTips接收两个参数：参数1控制弹窗显示隐藏，参数2标记是否点击确定按钮(点击：true) -->
    <yioks-tips :showTips="tipsFlag"
                :tips="tipMsg"
                :loading="loading"
                @hideTips="hideTipsDialog"></yioks-tips>
    <yioks-tips :showTips="levelFlag"
                :tips="levelMsg"
                @hideTips="hideLevelTips"></yioks-tips>
  </div>
</template>
<script>
  import TrainClassMixin from '@/minix/TrainClass';
  import {editClassInfoAjax, classDefaultLinks, getClassDetail, testClassData,class_train_periods} from "@/api/agency/agency";
  import {operationMsgSave} from "@/api/common/api";
  import {correctStatus} from "@/assets/js/apiStatus";
  import {levelName,id_types} from "@/assets/js/select";
  import commonFun from "@/assets/js/yioks";
  import { mapGetters, mapActions } from "vuex";
  import { viewTemplateItem } from "@/api/system_manager/api";
  import uploadMixin from "@/minix/uploadMixin";
  const {mobile_phone, idCard_number,email,checkWork,checkHkongMacao,checkTaiwOld,checkPassport,checkHMT} = commonFun;
  const minStus = 18;
  const maxStus = 24;
  const HOSTURL = process.env.VUE_APP_URL;
  const TRUE_FLAG = 'Y', FALSE_FLAG = 'N', CLASS_NAME = 'D级教练员培训班', SPLIT_CHAR = ',';
  const dataTestResults = Array(maxStus).fill(null).map(() => ({
    phone: {bool: false, msg: ""},
    id_num: {bool: false, msg: ""},
    name: {bool: false, msg: ""}
  }));
  const dataTestResultsTea = Array(2).fill(null).map(() => ({
    id_number: {bool: false, msg: ""},
    name: {bool: false, msg: ""}
  }));

  export default {
    name: "EditClass",
    props: {
      // 来自路由传递的值
      classId: [String, Number]
    },
    mixins: [TrainClassMixin,uploadMixin],
    data() {
      const validatePhone = (rule, value, callback, bool, index) => {
        if (mobile_phone(value)) {
          if (bool) {
            // 如果后台校验手机号有问题
            if (dataTestResults[index].phone.bool) {
              // console.log("后台校验手机");
              callback(new Error(dataTestResults[index].phone.msg));
            } else {
              callback();
            }
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入有效的11位手机号"));
        }
      };
      const validateEmail = (rule, value, callback, bool, index) => {
        if(value == ''){
          callback();
        }
        if (email(value)) {
          if (bool) {
            // 如果后台校验手机号有问题
            if (dataTestResults[index].email.bool) {
              // console.log("后台校验手机");
              callback(new Error(dataTestResults[index].email.msg));
            } else {
              callback();
            }
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入格式正确的邮箱"));
        }
      };
      const validateStrLength = (rule, value, callback, bool, index) => {
        if(value == ''){
          callback();
        } else {
          const strLen = String(value).length;
          if(strLen > 20) {
            callback(new Error("输入工作单位长度不应超过20"));
          } else {
            callback()
          }
        }
        //  else {
        //   callback(new Error("请输入格式正确的邮箱"));
        // }
      };
      const validateFile = (rule, value, callback, bool, index) => {
        console.log(value)
        if (value && value.length > 0) {
          callback();
        } else {
          callback(new Error("请上传文件"));
        }
        //  else {
        //   callback(new Error("请输入格式正确的邮箱"));
        // }
      };
      const validateNumberId = (rule, value, callback, bool, index) => {
        let id_type = this.stusData.stusInfoList[index].id_type
        let rules ;
        if(id_type==='id_number'){rules=idCard_number}
        else if(id_type==='idTypeCode_wgjzz'){rules=checkWork}
        else if(id_type==='passport'){rules=checkPassport}
        else if(id_type==='TAI'){rules=checkTaiwOld}
        else if(id_type==='HM'){rules=checkHkongMacao}
        else if(id_type==='idTypeCode_HMT'){rules=checkHMT}
        if (rules(value)) {
          if (bool) {
            if (dataTestResults[index].id_num.bool) {
              callback(new Error(dataTestResults[index].id_num.msg));
            } else {
              callback();
            }
          } else {
            callback();
          }
        } else callback(new Error("请输入有效的证件号"));
      };
      const validateNumberIdNO = (rule, value, callback, bool, index) => {
        let id_type = this.formData.teacher_zhuli[index].id_type
        let rules ;
        if(id_type==='id_number'){rules=idCard_number}
        else if(id_type==='idTypeCode_wgjzz'){rules=checkWork}
        else if(id_type==='passport'){rules=checkPassport}
        else if(id_type==='TAI'){rules=checkTaiwOld}
        else if(id_type==='HM'){rules=checkHkongMacao}
        else if(id_type==='idTypeCode_HMT'){rules=checkHMT}
        if(value){
          if (rules(value)) {
            if (bool) {
              if (dataTestResultsTea[index].id_number.bool) {
                callback(new Error(dataTestResultsTea[index].id_number.msg));
              } else {
                callback();
              }
            } else {
              callback();
            }
          } else callback(new Error("请输入有效的证件号"));
        } else{
          callback();
        }
        
      };
      const validateName = (rule, value, callback, bool, index) => {
        if (value === "") {
          callback(new Error("请输入姓名"));
        } else {
          if (bool) {
            // console.log(dataTestResults[index].name.bool);
            if (dataTestResults[index].name.bool) {
              callback(new Error(dataTestResults[index].name.msg));
            } else {
              callback();
            }
          } else {
            callback();
          }
        }
      };
      const stusInfoList = Array(maxStus)
        .fill("")
        .map((item, idx) => {
          return {
            name: "",
            phone: "",
            id_num: "",
            is_fast: 0,
            document_url: "",
            document_name: "",
            fileList: [],
            id: idx,
            id_type:'id_number'
          };
        });
      return {
        minStus,
        id_types,
        maxStus,
        repeatSubmit: false,
        showDateTime: false,
        validatePhone,
        validateEmail,
        validateStrLength,
        validateNumberId,
        validateNumberIdNO,
        validateName,
        validateFile,
        // 表示是否是由批量录入弹窗中的保存按钮吊起的录入名单弹窗
        excelDiaLetStusDiaOpen: false,
        stusData: {
          stusInfoList: [...stusInfoList]
        },
        contactData: {
          contactInfoList: []
        },
        ifStuDiaShow: false,
        ifContactDiaShow: false,
        ifExcelDiaShow: false,
        optionalAssistantLec: [],
        provinceList: [],
        cityList: [],
        countyList: [],
        lecturerList: [], // 讲师
        lecturerStore: [], // 讲师备份
        assistantLecturerList: [], // 助理讲师
        assistantStore: [], // 助理讲师备份
        assistantIdx: -1,
        formData: {
          selectedAddress: '',  // 报名举办地
          status: "", // 系统管理员编辑培训班，点击保存时状态
          ifLodging: false, // 是否统一安排住宿  原默认 false
          ifEat: false, // 是否统一安排就餐  原默认 false
          ifTravel:false, //是否统一安排差旅
          curriculum: "", // 培训课表图片
          group_mode: 6, // 培训班小组表 根据长度进行判断
          // 主办机构
          hostOrg: [
            {
              val: "",
              key: Date.now(),
              placeholder: "请填写主办机构"
            }
          ],
          // 承办机构
          underOrg: [
            {
              val: "",
              key: Date.now(),
              placeholder: "请填写承办机构"
            }
          ],
          // 协办机构
          assistOrg: [
            {
              val: "",
              key: Date.now(),
              placeholder: "请填写协办机构"
            }
          ],
          class_level: "",
          className: "", // 培训班名称
          trainStart: "", // 培训开始日期
          trainEnd: "", // 培训结束日期
          reportStart: "", // 报到开始日期
          reportEnd: "", // 报到开始时间
          leaveDate: "",
          leaveTime: "",
          // 开班地区 省市
          classAddress: {
            province: "",
            city: "",
            county: ""
          },
          period: 1, // 期数
          lecturer: "", // 主讲师
          // 助理讲师
          assistantLecturer: [
            {
              val: "",
              key: Date.now(),
              placeholder: "(空)",
              isTestErr: null
            }
          ],
          // 助理讲师
          assistantLecturerSumbit: [
            {
              val: "",
              key: Date.now(),
              placeholder: "(空)",
              isTestErr: null
            }
          ],
          // 实习讲师
          fieldworkLecturer: [
            {
              val: "",
              key: Date.now(),
              placeholder: "如有实习讲师，可在此输入"
            }
          ],
          teacher_zhuli:[{
            name: "",
            key: Date.now(),
            id_number:"",
            index_id:0,
            id_type:"id_number"
          }],
          teacher_zhuli_sumbit:[{
            name: "",
            key: Date.now(),
            id_number:"",
            id_type:"id_number",
            index_id:0
          }],
          cost: "", // 培训费用
          lodgingPlace: "", // 住宿地点
          lodgingPrice: 1, // 住宿费用类型
          eatPlace: "", // 就餐地点
          eatPrice: 1, // 就餐费用类型
          travelPrice:1,
          reportAddress: "", // 报到地点
          trainAddress: "", // 训练场地
          courseAddress: "", // 理论课场地
          saveContact: [],
          saveStus: JSON.parse(JSON.stringify(stusInfoList)),
          is_special_train: 0,
        },
        levelName,
        stusErrLen: null,
        teacherZhuliErrLen: null,
        timetableFlat: null, // 标记如果用户未上传图片则不向后台传图片的url
        timetableCover: null, // 课程表图片回显url地址
        selectAddress: [],
      };
    },
    computed: {
    ...mapGetters(["getStoreOrgData"]),
      userType() {
        return this.$store.state.userInfo.member_type;
      },
      isCountyNeeded() {
        if(this.getStoreOrgData) {
          const { org_level } =  this.getStoreOrgData;
          return this.getStoreOrgData.org_level === 'city' ? true : false
        } else {
          return false
        }
      }
    },
    watch: {
      "formData.trainStart": {
        handler: function (val) {
          const start = new Date(val).getTime();
          const end = new Date(this.formData.trainEnd).getTime()
          // 选择开始日期时候也将结束日期默认后推一周，注意 NaN 与任何值(包括自身)比较大小都为 false
          if (start > end) {
            if (this.formData.class_level === "C") {
              this.formData.trainEnd = Number(val) + 24 * 60 * 60 * 1000 * 13;
            } else {
              this.formData.trainEnd = Number(val) + 24 * 60 * 60 * 1000 * 7;
            }
            // this.formData.trainEnd = Number(val) + 24 * 60 * 60 * 1000 * 6;
          }
        }
      },
      "formData.trainEnd": {
        handler(val) {
          if (val > new Date(this.formData.leaveDate).getTime()) {
            const date = new Date(val);
            this.formData.leaveDate = date.getFullYear() + '-' + (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1)) + '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate());
          }
        },
      }
    },
    created() {
      // this.copyData = JSON.parse(JSON.stringify(this.formData));
      this.getProvinceList();
      this.getClassInfo();
    },
    mounted() {
      // this.getDataForSelectAddress();
    },
    methods: {
      // 删除
      handleSocreDocRemove(file, fileList, index) {
        this.stusData.stusInfoList[index].document_name = "";
        this.stusData.stusInfoList[index].document_url = "";
        this.stusData.stusInfoList[index].fileList = [];
      },
      // 删除
      handleScoreDocUoloadCheck(file, fileList, index) {
        this.$message.warning(`每个学员最多只能上传一个文件。如果您需要修改已上传文件，请先删除已上传的文件后再重新上传。`);
      },
      beforeUpload(file) {
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error("文件大小不能超过50M!");
          return false;
        }

        if (!/^.*\.(pdf)$/i.test(file.name)) {
          this.$message.error("请上传pdf格式的文件!");
          return false;
        }
        let param = {
          document: file,
        }; // 多此一举？
        for (const key in param) {
          if (param.hasOwnProperty(key)) {
            this.$set(this.fileUpParam, key, param[key]);
          }
        }
      },

      handleUploadScoreSuccess(res, file, index) {
        this.stusData.stusInfoList[index].document_name = res.result.document_name;
        this.stusData.stusInfoList[index].document_url = res.result.document_url;
        this.stusData.stusInfoList[index].fileList = [{name:res.result.document_name,url:res.result.document_url}];
        this.$refs['upload'+index][0].clearValidate();

      },
      changeState(val){
        if (val){
          let params={c_id:this.classId, start_date:val, class_level:this.formData.class_level,class_train_type:"train"}

          class_train_periods(params).then(({data:{status,result}})=>{
            if (Number(status)===0){
              this.$set(this.formData,'period',result.periods)
            }
          })
        }
      },
      backComfimDialog(bool, sure) {
        this.backComfim = bool;
        if (sure) {
          /*this.$router.push({
            name: "TrainingClassDetail",
            params: {classId: this.classId}
          });*/
          this.$router.go(-1);
        }
      },
      // 显示后台校验24个学员名单的结果
      testStusInfo(idx, key, msg, i) {
        const index = idx - 1;
        dataTestResults[index][key].bool = true;
        dataTestResults[index][key].msg = msg;
        this.$nextTick(() => {
          this.$refs["stusDialogForm"].validateField(
            "stusInfoList." + index + "." + key
          );
          if (this.stusErrLen - 1 === i) {
            for (const item of dataTestResults) {
              for (const key in item) {
                if (item.hasOwnProperty(key)) {
                  item[key].bool = false;
                  item[key].msg = "";
                }
              }
            }
          }
        });
      },
      // 显示后台校验讲师助理名单的结果
      testTeaInfo(idx, key, msg, i) {
        const index = idx;
        dataTestResultsTea[index].id_number.bool = true;
        dataTestResultsTea[index].id_number.msg = msg;
        this.$nextTick(() => {
          this.$refs["mainForm"].validateField(
            "teacher_zhuli." + index + "." + "id_number"
          );
          if (this.teacherZhuliErrLen-1  === i) {
            for (const item of dataTestResultsTea) {
              item.id_number.bool = false;
              item.id_number.msg = "";
              
            }
          }
        });
      },
      // 显示后台校验助理讲师列表的结果
      testAss(id, msg) {
        this.formData.assistantLecturer.forEach((item, index) => {
          if (String(item.val) === id) {
            item.isTestErr = true;
            item.errMsg = msg;
            this.$refs["mainForm"].validateField(
              "assistantLecturer." + index + ".val"
            );
            // 重置 isTestErr 的语句必须在表单校验之后立即执行，不能是异步语句
            item.isTestErr = false;
            item.errMsg = '';
          }

        });
      },
      // 是否确定提交数据弹窗
      hideTipsDialog(bool, sure) {
        if (sure) {
          // 提交数据
          this.ajaxCreatClass({status: this.ajaxStatus}, bool);
        } else {
          this.tipsFlag = bool;
        }
      },
      // 获取培训班基本信息
      getClassInfo(doOtherThing = () => {
      }) {
        const {nullToStr} = this.$yioks
        getClassDetail({
          c_id: this.classId
        }).then(({data}) => {
          if (data.status === correctStatus) {
            const {class_info, group_list} = data.result;
            this.$set(this.formData, "class_level", class_info.class_level);
            this.$set(this.formData, "is_special_train", Number(class_info.is_special_train));
            this.copyLevel = class_info.class_level;
            this.$set(this.formData, "className", this.levelName[class_info.class_level]);
            this.getLecturerList();
            this.$set(this.formData, "status", class_info.status);
            this.timetableFlat = nullToStr(class_info.timetable_picture);
            // this.timetableCover = this.timetableFlat && HOSTURL + this.timetableFlat

            if (this.timetableFlat) {
              this.timetableCover = HOSTURL + this.timetableFlat;
            } else {
              switch (class_info.class_level) {
                case "C":
                  this.timetableCover = this.$options._myOpt.class_c;
                  break;
                case "D":
                  this.timetableCover = this.$options._myOpt.class_d;
                  break;
              }
            }
            // this.$set(this.formData, "group_mode", group_list.length === 6 ? 4 : 3); // 回传默认分组
            this.$set(this.formData, "group_mode", group_list.length); // 回传默认分组
            this.formData.curriculum = nullToStr(class_info.timetable_picture);
            this.formData.hostOrg = nullToStr(class_info.sponsor).split(SPLIT_CHAR).map((item, index) => ({
              val: item,
              key: index,
              placeholder: "请填写主办机构"
            }));
            this.formData.underOrg = nullToStr(class_info.organizer).split(SPLIT_CHAR).map((item, index) => ({
              val: item,
              key: index,
              placeholder: "请填写承办机构"
            }));
            this.formData.assistOrg = nullToStr(class_info.co_organizer).split(SPLIT_CHAR).map((item, index) => ({
              val: item,
              key: index,
              placeholder: "请填写协办机构"
            }));
            this.formData.classAddress.province = String(nullToStr(class_info.province_id));
            // 这句必须放在为表单回显的city值赋值之前，因为 provinceChange 方法中会重置回显表单中的city值为空，所以这句下面需要重新为city赋值
            this.provinceChange();
            this.formData.classAddress.city = String(nullToStr(class_info.city_id));
            this.cityChange();
            this.formData.classAddress.county = String(nullToStr(class_info.county_id));
            this.formData.period = nullToStr(class_info.periods)
            // 系统管理员编辑可以为今天，地方机构编辑只能为一周之后的时间
            const tempDate = new Date().setHours(0, 0, 0, 0);
            let timestamp = new Date(tempDate).getTime();
            // 系统管理员 可以选择当前日期， 机构管理员只能选择当前日期+7  暂时保存中的 需要加7天  已经拒绝的 不需要加
            (this.userType === 'organ') && (class_info.status === 'Edit') && (timestamp += 7 * 24 * 60 * 60 * 1000);
            if (class_info.start_date < timestamp) {
              this.formData.trainStart = '';
              this.formData.trainEnd = '';
            } else {
              this.$set(this.formData, "trainStart", Number(class_info.start_date));
              this.$set(this.formData, "trainEnd", Number(class_info.end_date));
            }
            // this.formData.trainStart =  Math.max(nullToStr(class_info.start_date),Date.now())
            // this.formData.trainEnd = nullToStr(class_info.end_date)
            // this.formData.lecturer = String(nullToStr(class_info.teacher_off_ids))
            // el-select 值为 Number类型
            this.formData.lecturer = nullToStr(class_info.teacher_off_ids)
              ? Number(class_info.teacher_off_ids)
              : "";
            this.formData.assistantLecturer = nullToStr(class_info.teacher_ids).split(SPLIT_CHAR).map((item, index) => {
              // console.log(item==='');
              return {
                val: item === '' ? '' : (item ==='足协指派' ? (['super','system'].includes(this.userType) ? '': item ) : Number(item)),
                key: index,
                isTestErr: null,
                placeholder: "(空)",
              };
            });
            this.formData.fieldworkLecturer = nullToStr(class_info.intern_teacher).split(SPLIT_CHAR).map((item, index) => ({
              val: item,
              key: index,
              isTestErr: null,
              placeholder: "如有实习讲师，可在此输入",
            }));
            this.formData.ifLodging = Boolean(class_info.is_accommodation === TRUE_FLAG);
            this.formData.ifEat = Boolean(class_info.is_repast === TRUE_FLAG);
            this.formData.ifTravel = Boolean(class_info.is_travel === TRUE_FLAG);
            this.formData.cost = nullToStr(class_info.train_cost)
            const repStartDate = new Date(class_info.regis_start_time);
            const leaveDate = new Date(class_info.departure_time)
            // 系统管理员 可以选择当前日期， 机构管理员只能选择当前日期+7
            if (class_info.start_date < timestamp) {
              this.formData.reportStart = '';
              this.formData.reportEnd = '';
              this.formData.leaveDate = '';
              this.formData.leaveTime = '';
            } else {
              this.formData.reportStart = repStartDate.getFullYear() + '-' + (repStartDate.getMonth() + 1 < 10 ? "0" + (repStartDate.getMonth() + 1) : (repStartDate.getMonth() + 1)) + '-' + (repStartDate.getDate() < 10 ? '0' + repStartDate.getDate() : repStartDate.getDate());
              this.formData.reportEnd = (repStartDate.getHours() < 10 ? "0" + repStartDate.getHours() : repStartDate.getHours()) + ':' + (repStartDate.getMinutes() < 10 ? "0" + repStartDate.getMinutes() : repStartDate.getMinutes())
              // 离会时间 回显
              this.formData.leaveDate = leaveDate.getFullYear() + '-' + (leaveDate.getMonth() + 1 < 10 ? "0" + (leaveDate.getMonth() + 1) : (leaveDate.getMonth() + 1)) + '-' + (leaveDate.getDate() < 10 ? '0' + leaveDate.getDate() : leaveDate.getDate());
              this.formData.leaveTime = (leaveDate.getHours() < 10 ? "0" + leaveDate.getHours() : leaveDate.getHours()) + ':' + (leaveDate.getMinutes() < 10 ? "0" + leaveDate.getMinutes() : leaveDate.getMinutes());
            }
            this.formData.lodgingPlace = nullToStr(class_info.residence_address);
            this.formData.eatPlace = nullToStr(class_info.repast_address);
            this.formData.lodgingPrice = class_info.accommodation_cost_type === TRUE_FLAG ? 1 : 2;
            this.formData.eatPrice = class_info.repast_cost_type === TRUE_FLAG ? 1 : 2;
            this.formData.travelPrice = class_info.travel_type === TRUE_FLAG ? 1 : 2;
            this.formData.reportAddress = nullToStr(class_info.regis_address);
            this.formData.trainAddress = nullToStr(class_info.training_address);
            this.formData.courseAddress = nullToStr(class_info.theory_address);
            const linkmanList = nullToStr(data.result.linkman_data).map(({email, name,work, mobile_phone}, index) => ({
              name,
              email,
              work,
              phone: mobile_phone || '',
              id: index
            }));
            this.formData.saveContact = [...linkmanList];
            this.contactData.contactInfoList = JSON.parse(JSON.stringify(this.formData.saveContact));
            this.testContact = true;
            if(data.result.teacherZhuli && data.result.teacherZhuli.length >0){
              const teacherZhuli = nullToStr(data.result.teacherZhuli).map(({id_number, id_type,name}, index) => ({
                id_number,
                id_type,
                name,
                index_id: index
              }));
              this.formData.teacher_zhuli = [...teacherZhuli];
            }
            const stusList = nullToStr(data.result.student_data).map(({id_number, user_name, mobile_phone, user_id,id_type,is_fast,document_url,document_name}, index) => ({
              name: user_name,
              phone: mobile_phone || '',
              id_num: id_number || '',
              is_fast: is_fast || 0,
              document_url: document_url || '',
              document_name: document_name || '',
              fileList:document_name?[{name:document_name,url:document_url}]:[],
              id: user_id,
              id_type,
            }));
            this.formData.saveStus = [...stusList];
            this.stusData.stusInfoList = JSON.parse(JSON.stringify(this.formData.saveStus));

            this.testStus = true;
            this.showDateTime = true;
          }
        });
      },
      async ajaxCreatClass(statusParam, bool) {
        const formdata = this.formData;
        const regis_start_time = this.getTimeStemp(formdata.reportStart, formdata.reportEnd); // 报到时间
        const departure_time = this.getTimeStemp(formdata.leaveDate, formdata.leaveTime); // 离会时间
        const ajaxParams = {
          c_id: this.classId,
          image_url: formdata.curriculum,
          sponsor: formdata.hostOrg.map(item => item.val).join(SPLIT_CHAR),
          organizer: formdata.underOrg.map(item => item.val).join(SPLIT_CHAR),
          co_organizer: formdata.assistOrg.map(item => item.val).join(SPLIT_CHAR),
          // name: formdata.className,
          class_level: formdata.class_level,
          province_id: formdata.classAddress.province,
          city_id: formdata.classAddress.city,
          county_id: formdata.classAddress.county,
          periods: formdata.period,
          start_date: formdata.trainStart,
          end_date: formdata.trainEnd,
          teacher_ids: formdata.assistantLecturer.map(item => item.val).join(SPLIT_CHAR),
          teacher_off_id: formdata.lecturer.toString(),
          intern_teacher: formdata.fieldworkLecturer
            .map(item => item.val)
            .join(SPLIT_CHAR),
          is_accommodation: formdata.ifLodging ? TRUE_FLAG : FALSE_FLAG,
          train_cost: formdata.cost,
          residence_address: formdata.lodgingPlace,
          accommodation_cost_type:
            formdata.lodgingPrice.toString() === "1" ? TRUE_FLAG : FALSE_FLAG,
          is_repast: formdata.ifEat ? TRUE_FLAG : FALSE_FLAG,
          repast_address: formdata.eatPlace,
          repast_cost_type: formdata.eatPrice.toString() === "1" ? TRUE_FLAG : FALSE_FLAG,
          is_travel: formdata.ifTravel ? TRUE_FLAG : FALSE_FLAG,
          travel_type:
          formdata.travelPrice.toString() === "1" ? TRUE_FLAG : FALSE_FLAG,
          regis_start_time,
          // regis_end_time: formdata.reportEnd,
          departure_time,
          regis_address: formdata.reportAddress,
          training_address: formdata.trainAddress,
          theory_address: formdata.courseAddress,
          group_mode: formdata.group_mode, // 分组模式
          class_linkman: JSON.stringify(
            formdata.saveContact.map(item => ({
              name: item.name,
              phone: item.phone,
              email: item.email,
              work:item.work,
            }))
          ),
          teacher_zhuli: JSON.stringify(
            formdata.teacher_zhuli.map((item,index) => ({
              name: item.name,
              id_number: item.id_number,
              id_type: item.id_type,
              index_id: index,
            }))
          ),
          student_list: JSON.stringify(
            formdata.saveStus.map(({name, phone, id_num,id_type,is_fast,document_url,document_name}) => ({
              name,
              phone,
              id_num,
              is_fast,
              document_url,
              document_name,
              id_type
            }))
          ),
          is_special_train: formdata.is_special_train,
          ...statusParam,
          class_the_quality: 'eleven',  // 十一人制数据
        };
        this.loading = true;
        if(statusParam.status === 'Audit'){
          ajaxParams.operation_type='submit_class';
          await operationMsgSave(JSON.parse(JSON.stringify(ajaxParams))).then(({data}) =>{
            ajaxParams.operation_msg_id=data.result.operationMsg.msg_id;
          })
        }
        // console.log('时间 ',formdata.reportStart, formdata.reportEnd, ajaxParams.regis_start_time)
        editClassInfoAjax(JSON.parse(JSON.stringify(ajaxParams))).then(({data}) => {
          this.loading = false;
          if (data.status === correctStatus) {
            /*this.$router.push({
              name: "TrainingClassDetail",
              params: {classId: this.classId}
            });*/
            this.$router.go(-1);
          } else {
            this.$message.error(`${data.msg}`);
            if (Number(data.status) === 436 || Number(data.status) === 439) {
              this.tipsFlag = bool;
              this.trainTimeAjaxErr = true;
              this.trainTimeAjaxErrMsg = data.msg;
              this.$refs['mainForm'].validateField('trainStart');
            }
          }
        }).catch(err => {
          this.loading = false;
          console.error(err);
        });
      },
      translateData(){
        // 判断是否都为空
        let { values } = Object;
        let tmp = [];
        this.formData.teacher_zhuli.map((item) => {
          var _item = {...item};
          _item.key='';
          _item.id_type='';
          _item.index_id='';
          const flag = values(_item).some((elem) => {
            return elem instanceof Array ? Boolean(elem.length) : Boolean(elem);
          });
          if (flag) {
            tmp.push(item);
          }
        });
        this.$set(this.formData, "teacher_zhuli_sumbit", tmp);
  
        const tmp1 = [];
        this.formData.assistantLecturer.map((item) => {
          var _item = {...item};
          _item.key='';
          _item.placeholder='';
          const flag = values(_item).some((elem) => {
            return elem instanceof Array ? Boolean(elem.length) : Boolean(elem);
          });
          if (flag) {
            tmp1.push(item);
          }
        });
        this.$set(this.formData, "assistantLecturerSumbit", tmp1);
      },
      // 提交审核
      startClass(status) {
        this.ajaxStatus = status;
        this.translateData();
        
        // 写了姓名或身份证号 就的写完整
        if(this.formData.class_level=== 'D'){
          let exit = 0;
          this.formData.teacher_zhuli_sumbit.map(item=>{
            if(!item.name || !item.id_number){
              this.$message.error("请填写讲师助理姓名或身份证号");
              exit = 1;
            }
          })
          if(exit) return;
        }
        if(status ==='Audit'){
          // 如果是D 助理讲师和讲师助理不能同时为空
          if(this.formData.class_level=== 'D'){
            if(!this.formData.teacher_zhuli_sumbit.length && !this.formData.assistantLecturerSumbit.length){
              this.$message.error("请填写助理讲师或者讲师助理");
              return
            }
          }
          // 如果是C 助理讲师必须填写
          if(this.formData.class_level=== 'C'){
            if(!this.formData.assistantLecturerSumbit.length){
              this.$message.error("请选择助理讲师");
              return
            }
          }
        }
        this.$refs['mainForm'].validate(valid => {
          if (valid) {
            const formdata = this.formData;
            testClassData({
              c_id: this.classId,
              periods: formdata.period,
              status,
              teacher_off_id: formdata.lecturer,
              application_id: formdata.application_id || '',
              teacher_ids: formdata.assistantLecturer
                .map(item => item.val)
                .join(SPLIT_CHAR),
              student_list: JSON.stringify(
                formdata.saveStus.map(({name, phone, id_num, id,id_type,is_fast,document_url,document_name}, index) => ({
                  name,
                  phone,
                  id_num,
                  id: index + 1,
                  is_fast,
                  document_url,
                  document_name,
                  id_type
                }))
              ),
              start_date: formdata.trainStart,
              end_date: formdata.trainEnd,
              class_level: formdata.class_level,
              is_special_train: formdata.is_special_train,
              teacher_zhuli: JSON.stringify(
                formdata.teacher_zhuli.map((item,index) => ({
                  name: item.name,
                  id_number: item.id_number,
                  id_type: item.id_type,
                  index_id: index,
                }))
              ),
              class_the_quality: 'eleven'
            }).then(({data}) => {
              if (data.status === correctStatus) {
                const {result} = data;
                switch (result.consequence.toLowerCase()) {
                  case "ok":
                    let stuTips = "";
                    let scoreTips = "";
                    if (result.stuHint) {
                      const {stuHintList} = result;
                      stuTips = "【" + stuHintList.slice(0, 3) + (stuHintList.length > 3 ? `等${stuHintList.length}人` : '') + "】曾经参加过此类培训，";
                    }
//                    if (result.coachHint) {
//                      const {coachHintList} = result;
//                      scoreTips = "【" + coachHintList.slice(0, 3) + (coachHintList.length > 3 ? `等${coachHintList.length}人` : '') + "】的成绩库成绩查询异常，";
//                    }
                    if (result.stuHint) {
                      this.tipMsg = `学员名单中${stuTips}请确认是否继续提交？`;
                      this.tipsFlag = true;
                      break;
                    }
                    if (status === 'Audit') {
                      this.tipMsg = "请确认是否继续提交？";
                    } else {
                      this.tipMsg = "请确认是否暂时保存？";
                    }
                    this.tipsFlag = true;
                    break;
                  case "error":
                    this.$message.error(this.$options._myOpt.rearEndErrorMsg);
                    // 显示后端校验
                    if (result.periodsErr) {
                      // 校验期数
                      this.periodAjaxTestErr = true;
                      this.periodAjaxTestMsg = result.periodsErr;
                      this.$refs["mainForm"].validateField("period");
                    }
                    if(result.teacherZhuliErr.length>0){
                      this.teacherZhuliErrLen = result.teacherZhuliErr.length;
                      this.$nextTick(() => {
                        for (const [
                          i,
                          {msg, index_id}
                        ] of result.teacherZhuliErr.entries()) {
                          this.testTeaInfo(index_id, 'id_number', msg, i);
                        }
                      });
                    }
                    if (result.studentErr.length > 0) {
                      this.stusErrLen = result.studentErr.length;
                      this.excelDiaLetStusDiaOpen = false;
                      // 校验学员名单
                      this.ifStuDiaShow = true;
                      this.$nextTick(() => {
                        for (const [
                          i,
                          {err, index_id}
                        ] of result.studentErr.entries()) {
                          for (const key in err) {
                            if (err.hasOwnProperty(key)) {
                              this.testStusInfo(index_id, key, err[key], i);
                            }
                          }
                        }
                      });
                    }
                    if (result.teaOffError) {
                      // 校验主讲师
                      this.lecturerAjaxTestErr = true;
                      this.lecturerAjaxTestMsg = result.teaOffError;
                      this.$refs["mainForm"].validateField("lecturer");
                    }
                    if (result.teacherErr.length > 0) {
                      // 校验助理讲师
                      for (const [i, {msg, id}] of result.teacherErr.entries()) {
                        this.testAss(id, msg);
                      }
                    }
                    this.periodAjaxTestErr = false;
                    this.lecturerAjaxTestErr = false;
                    break;
                }
              } else {
                this.$message.error(data.msg);
              }
            });
          } else {
            this.$message.error("必填项不能为空");
          }
        })
      },
      goBack() {
        this.backComfim = true;
      },
      addStus(idx) {
        if (this.stusData.stusInfoList.length >= maxStus) return false;
        this.stusData.stusInfoList.push({
          name: "",
          phone: "",
          id_num: "",
          is_fast: 0,
          document_url: "",
          document_name: "",
          fileList: [],
          id_type:'id_number'
        });
        this.$nextTick(() => {
          this.$refs["stuVs"].scrollTo({y: '100%'}, true);
        });
      },
      removeStus(idx) {
        if (this.stusData.stusInfoList.length <= 1) return false;
        this.$refs[`s`][idx].clearValidate();
      setTimeout(() => {
        this.stusData.stusInfoList.splice(idx, 1);
      }, 20);
      },
      changeClassLevel() {
        /*this.formData = {
          ...JSON.parse(JSON.stringify(this.copyData)),
          class_level: this.level,
          className: this.levelName[this.level],
        };*/
        this.$set(this.formData, "class_level", this.level);
        this.$set(this.formData, "className", this.levelName[this.level]);
        this.$set(this.formData, "lecturer", "");
        this.$set(this.formData, "assistantLecturer", [
          {
            val: "",
            key: Date.now(),
            placeholder: "(空)",
            isTestErr: null
          }
        ]);
        let cost;
        (this.level === "C") && (cost = "6000");
        (this.level === "D") && (cost = "3000");
        this.$set(this.formData, "cost", cost);
        this.copyLevel = this.level;
        switch (this.level) {
          case "C":
            this.timetableCover = this.$options._myOpt.class_c;
            break;
          case "D":
            this.timetableCover = this.$options._myOpt.class_d;
            break;
        }
        this.getLecturerList();
        setTimeout(() => {
          this.citySelErr = false;
          this.testStus = false;
          this.$refs["mainForm"].clearValidate();
        }, 0);
      },
      selectLevel(val) {
        this.level = val;
        this.levelFlag = true;
      },
      hideLevelTips(bool, sure) {
        this.levelFlag = bool;
        if (sure) {
          this.changeClassLevel();
        } else {
          this.$set(this.formData, "class_level", this.copyLevel);
        }
      },

      getDataForSelectAddress() {
        classDefaultLinks({
        class_the_quality: 'eleven'
      })
        .then(({ data }) => {
          if (data.status === correctStatus) {
            const {
              result: { venueData }
            } = data;
            if(venueData && venueData.length) {
              this.selectAddress = venueData.map(item => ({
                label: item.undertake_unit,
                value: item.venue_uuid,
              }))
            } else {
              this.selectAddress = [];
            }
          } else {
          }
        })
        .catch(err => {
          console.log(err);
        });
      },
      handleAddressChange(val) {
        if(val) {
          viewTemplateItem(val)
            .then(({data}) => {
              if(data.status !== 0 ) {
                this.$message.error(data.msg);
                return
              }
              const { venueInfo, linkmenData } = data.result;
              if(linkmenData && linkmenData.length) {
                this.contactData.contactInfoList = linkmenData.map(
                  ({ email, mobile_phone, name,work }, i) => ({
                    name,
                    email,
                    phone: mobile_phone,
                    work,
                    id: i + 1
                  })
                );
                this.testContact = true;
              } else {
              this.contactData.contactInfoList = [];
                this.testContact = false;
              }
              this.formData.saveContact = JSON.parse(
                JSON.stringify(this.contactData.contactInfoList)
              );

              if(venueInfo) {
                const { province_id, city_id, county_id,
                              regis_address, practice_addredd, theory_address,
                              student_accommodation_address, student_eat_address
                          } = venueInfo;
                          theory_address && (this.$set(this.formData, 'courseAddress', theory_address))
                          practice_addredd && (this.$set(this.formData, 'trainAddress', practice_addredd))
                          regis_address && (this.$set(this.formData, 'reportAddress', regis_address))
                          student_accommodation_address && (this.$set(this.formData, 'lodgingPlace', student_accommodation_address))
                          student_eat_address && (this.$set(this.formData, 'eatPlace', student_eat_address))
                if(province_id) {
                              this.formData.classAddress.province = String(province_id);
                              // 这句必须放在为表单回显的city值赋值之前，因为 provinceChange 方法中会重置回显表单中的city值为空，所以这句下面需要重新为city赋值
                              this.provinceChange();
                              this.formData.classAddress.city = String(city_id);
                              this.cityChange();
                              this.formData.classAddress.county = String(county_id);
                          }
              }
            })
            .catch(err => {
              console.error('err', err)
            })
        } else {
          this.clearOlderData();
        }
      },
      clearOlderData() {
        this.formData = Object.assign({}, this.formData, {
          courseAddress: '',
          trainAddress: '',
          reportAddress: '',
          lodgingPlace: '',
          eatPlace: '',
        })
        this.formData.classAddress.province = '';
        this.provinceChange();
      },
    },

  };
</script>

<style lang="stylus">
  @import '~@/assets/css/class';
  .form-oneline-wrap.formPos{
    position:relative;
    .stu-opt{
      position:absolute;
      right: -8px;
      top: 18px;
      width:60px !important;
    }
  }
  .id_number_tips_error{
    .el-form-item__error{
      left: -234px;
    }
  }
</style>

